export default "__VITE_ASSET__4xxIVdBu__"